import { render, staticRenderFns } from "./rescreen.vue?vue&type=template&id=4e06fa0e&scoped=true"
import script from "./rescreen.vue?vue&type=script&lang=js"
export * from "./rescreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e06fa0e",
  null
  
)

export default component.exports